import { defineComponent as _defineComponent } from 'vue'
import { isInFreeTrial } from '@/ui/auth/auth';
  import { Button } from '@/ui/components/Button';
  import { useModal } from '@/ui/concerns/modals/useModal';
  import ContactUsModal from '@/ui/pages/subscription/Chargebee/details/ContactUsModal.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DarkContactUs',
  setup(__props) {

  const [isModalOpen, onModalOpen, onModalClose] = useModal();

return { __sfc: true,isModalOpen, onModalOpen, onModalClose, isInFreeTrial, Button, ContactUsModal }
}

})